import {initReactI18next} from 'react-i18next';
import i18n from 'i18next';
import {en} from './locales/en';
import {kr} from './locales/kr';

const resources = {
  ko: {
    translation: kr
  },
  en: {
    translation: en
  }
};

// URL에서 언어 파라미터 읽기
const getLanguageFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const langParam = params.get('lang');

  // lang 파라미터가 있고 유효한 언어면 해당 언어 사용, 아니면 한국어
  if (langParam && (langParam === 'en' || langParam === 'ko')) {
    return langParam;
  }
  return 'ko';
};

i18n
  .use(initReactI18next) // React와 i18next 연결
  .init({
    resources,
    lng: getLanguageFromURL(), // URL에서 언어 읽기
    fallbackLng: 'ko', // 번역 없을 경우 대체 언어
    interpolation: {
      escapeValue: false // React는 XSS 보호를 자체적으로 처리
    }
  });

export default i18n;
